import React, { useState, useEffect } from "react";

const MultiToggleSwitch = ({ type = 'default', options, defaultValue, onChange, disabled = false }) =>
{
    const [selected, setSelected] = useState(defaultValue || options[0]?.value);

    const handleSelect = (val) => {
        if (disabled) return;
        setSelected(val);
        if (onChange) {
            onChange(val);
        }
    };

    useEffect(() => {
        setSelected(defaultValue);
    }, [defaultValue]);

    return (
        <div
            className={`${type === 'simple' ? 'multiToggle multiSimpleToggle' : 'multiToggle'} ${disabled ? 'multiToggleDisabled' : ''}`}
        >
            {options.map((option) => (
                <button
                    type="button"
                    key={option.value}
                    className={`multiToggleBtn ${
                        selected === option.value ? 'multiToggleActive' : ""
                    } ${disabled ? 'multiToggleBtnDisabled' : ''}`}
                    onClick={() => handleSelect(option.value)}
                    disabled={disabled}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
};

export default MultiToggleSwitch;